// src/routes.js
export const routes = [
    // Core Pages
    { url: "/",                                 view: "core_home",                  name: "home" },
    { url: "/contact",                          view: "core_contact",               name: "contact" },

    // Auth Pages
    { url: "/login",                            view: "auth_login",                 name: "login", base:true},
    { url: "/logout",                           view: "auth_logout",                name: "logout", auth: true, base:true},
    
    { url: "/forgot-password",                  view: "auth_forgot_password",       name: "forgot_password", base:true},
    { url: "/reset-password",                   view: "auth_reset_password",        name: "reset_password", base:true},
    { url: "/reset-password/success",           view: "auth_reset_password_success", name: "reset_password_success", base:true},
    { url: "/register",                         view: "auth_register",              name: "register", base:true},
    { url: "/register/success",                 view: "auth_register_success",      name: "register_success", base:true},
    { url: "/activate",                         view: "auth_activate",              name: "activate", base:true},
    { url: "/activate/success",                 view: "auth_activate_success",      name: "activate_success", base:true},
    { url: "/activate/failed",                  view: "auth_activate_failed",       name: "activate_failed", base:true},

    { url: "/account/valuecard",                view: "auth_valuecard",             name: "valuecard", auth: true, nested:"account"},
    { url: "/account/change-email",             view: "auth_change_email",          name: "change_email", auth: true, nested:"account"},
    { url: "/account/change-password",          view: "auth_change_password",       name: "change_password", auth: true, nested:"account"},

    { url: "/account/profile",                  view: "auth_profile",               name: "profile", auth: true, nested:"account"},

    // Blog Pages
    { url: "/blog",                             view: "blog_blog_list",             name: "blog"},
    { url: "/blog/:slug",                       view: "blog_blog_details",          name: "blog_details" },

    // Shop Pages
    { url: "/product/:sku",                    view: "core_home",                  name: "product_modal" },
    { url: "/catalogue/:sku",                   view: "shop_catalogue_details",     name: "catalogue_details" },

    { url: "/shop/orders",                      view: "shop_orders_list",           name: "orders", auth: true, nested:"account"},
    { url: "/shop/orders/:id",                  view: "shop_orders_details",        name: "orders_details", auth: true, nested:"account"},
    { url: "/shop/returns",                     view: "shop_returns_list",          name: "returns", auth: true, nested:"account"},
    { url: "/shop/returns/:id",                 view: "shop_returns_details",       name: "returns_details", auth: true, nested:"account"},

    { url: "/shop/checkout",                    view: "shop_checkout",              name: "checkout" },
    { url: "/shop/quote-approval/:token",       view: "shop_quote_approval",        name: "quote_approval" },

    { url: "/shop/checkout/gateway",            view: "shop_checkout_gateway",          name: "checkout_gateway" },
    { url: "/shop/checkout/gateway/success",    view: "shop_checkout_gateway_success",  name: "checkout_gateway_success" },
    { url: "/shop/checkout/gateway/failed",     view: "shop_checkout_gateway_failed",   name: "checkout_gateway_failed" },

    { url: "/shop/checkout/confirm/:id",        view: "shop_checkout_confirm",      name: "checkout_confirm" },
    { url: "/shop/basket",                      view: "shop_basket",                name: "basket" },
    { url: "/shop/basket/success",              view: "shop_success",               name: "checkout_success", auth: true},
    { url: "/shop/basket/failed",               view: "shop_failed",                name: "checkout_failed", auth: true},

    { url: "/shop/quote",                       view: "shop_quote",                 name: "quote", nested:"account"},

    { url: "/search",                           view: "core_search",                name: "search"},
    
    { url: "/:slug",                            view: "core_content",               name: "page" },

    { url: "/support/faq",                      view: "core_faq",                   name: "faq" },

    { url: "/support/make-a-return",            view: "shop_return",                name: "return" },

    { url: "/change-email/confirm/:uid/:token", view: "auth_change_email_message", name: "change_email_confirm", base: true },

    { url: "*",                                 view: "core_not_found",             name: "not_found" },

];

export default routes;
